import SendRecipient from './SendRecipient';

export default SendRecipient;
